import styled from 'styled-components'
import { Body } from '@shipt/design-system-typography'

interface Props {
  className?: string
  totalResults: number
}

export const SearchResultsText = ({ className, totalResults }: Props) => (
  <ResultsText className={className} size="sm" variant="secondary">
    {totalResults} {totalResults === 1 ? 'item' : 'items'}
  </ResultsText>
)

const ResultsText = styled(Body)`
  display: inline-block;
  white-space: nowrap;
`
